var TaskTypePage = /** @class */ (function () {
    function TaskTypePage(obj) {
        this.title = obj && obj.title || "";
        this.headerClass = obj && obj.headerClass || "";
        this.formHeight = obj && obj.formHeight || 0;
        this.showAttachments = obj && obj.showAttachments || false;
        this.attachmentsHeight = obj && obj.attachmentsHeight || 0;
        this.enableDialogButtons = obj && obj.enableDialogButtons || false;
        this.fields = obj && obj.fields || [];
    }
    TaskTypePage.prototype.getHash = function () {
        return this.title + "#" + this.headerClass + "#" + this.fields.join(";");
    };
    return TaskTypePage;
}());
export { TaskTypePage };
